import {
	createContext,
	default as React,
	type ReactNode,
	useContext,
} from "react";
import { useComplexState } from "use-complex-state";
import { AssetDetailsReducer } from "../reducers/assetDetailsReducer";

const AssetDetailsContext = createContext({
	state: AssetDetailsReducer.getInitialState(),
	actions: AssetDetailsReducer.actions,
});

export const useAssetDetailsContext = () => useContext(AssetDetailsContext);

export const AssetDetailsProvider = ({ children }: { children: ReactNode }) => {
	const [state, actions] = useComplexState({
		initialState: AssetDetailsReducer.getInitialState(),
		reducers: AssetDetailsReducer.caseReducers,
	});

	return (
		<AssetDetailsContext.Provider value={{ state, actions }}>
			{children}
		</AssetDetailsContext.Provider>
	);
};
